// player information
export const PLAYER_LOADED = "PLAYER_LOADED";
export const UPDATE_DURATION = "UPDATE_DURATION";
export const UPDATE_POSITION = "UPDATE_POSITION";

// comments
export const CLEAR_COMMENTS = "CLEAR_COMMENTS";
export const UPDATE_COMMENTS = "UPDATE_COMMENTS";
export const ADD_COMMENT = "ADD_COMMENT";
export const UPDATE_COMMENT = "UPDATE_COMMENT";
export const MASK_COMMENT = "MASK_COMMENT";

// media
export const REMOVE_RELATED_THUMBNAIL = "REMOVE_RELATED_THUMBNAIL";

// ui state
export const SELECT_COMMENT_TYPE = "SELECT_COMMENT_TYPE";
export const SHOW_MORE_COMMENTS = "SHOW_MORE_COMMENTS";
export const START_LOADING = "START_LOADING";
export const FINISH_LOADING = "FINISH_LOADING";
export const ADD_ERROR = "ADD_ERROR";
export const ADD_ERRORS = "ADD_ERRORS";
export const REMOVE_ERROR = "REMOVE_ERROR";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const UPDATE_MEDIA_DESCRIPTION_VISIBLITY = "UPDATE_MEDIA_DESCRIPTION_VISIBLITY";
export const START_COMMENT = "START_COMMENT";
export const START_EDITING_COMMENT = "START_EDITING_COMMENT";
export const START_COMMENT_REPLY = "START_COMMENT_REPLY";
export const STOP_EDITING_COMMENT = "STOP_EDITING_COMMENT";
export const START_SCRUB = "START_SCRUB";
export const UPDATE_SCRUB = "UPDATE_SCRUB";
export const FINISH_SCRUB = "FINISH_SCRUB";
export const SHOW_SCRUBBER = "SHOW_SCRUBBER";
export const UPDATE_COMMENT_FIELD = "UPDATE_COMMENT_FIELD";
export const UPDATE_CREATE_FORM = "UPDATE_CREATE_FORM";
export const CLEAR_CREATE_FORM = "CLEAR_CREATE_FORM";
export const GO_TO_COMMENT = "GO_TO_COMMENT";
export const FINISH_GO_TO_COMMENT = "FINISH_GO_TO_COMMENT";
export const SHOW_COMMENT_MENU = "SHOW_COMMENT_MENU";
export const HIDE_COMMENT_MENU = "HIDE_COMMENT_MENU";
export const UPDATE_DOWNLOAD_MENU_VISIBLITY = "UPDATE_DOWNLOAD_MENU_VISIBLITY";

// instances
export const CLEAR_INSTANCES = "CLEAR_INSTANCES";
export const UPDATE_INSTANCES = "UPDATE_INSTANCES";
export const SET_INSTANCE = "SET_INSTANCE";

// likes
export const CLEAR_LIKES = "CLEAR_LIKES";
export const UPDATE_LIKES = "UPDATE_LIKES";
export const SET_LIKED = "SET_LIKED";
export const UPDATING_LIKED = "UPDATING_LIKED";

// snippets
export const CLEAR_SNIPPETS = "CLEAR_SNIPPETS";
export const UPDATE_SNIPPETS = "UPDATE_SNIPPETS";

// stats
export const CLEAR_STATS = "CLEAR_STATS";
export const UPDATE_STATS = "UPDATE_STATS";